import { useTranslation } from "react-i18next";
import ListGroup from "./controls/ListGroup";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import ObjectValue from "./controls/ObjectValue";
import TextValue from "./controls/TextValue";
import MeasureValue from "./controls/MeasureValue";
import LabeledValue from "./controls/LabeledValue";
import BooleanValue from "./controls/BooleanValue";
import { AreaAcopioSolidosSchema } from "../data/AreaAcopioSolidosSchema";

export function AreaAcopioSolidoList({ value, select, remove, disabled }) {
  const { t } = useTranslation();
  return (
    <ListGroup>
      {value.map((areaAcopioSolido, index) => {
        const isInvalid = !AreaAcopioSolidosSchema.isValidSync(
          areaAcopioSolido,
          { abortEarly: false },
        );
        return (
          <ListGroupObjectItem
            key={areaAcopioSolido.orden}
            index={index}
            indexLabel={t("areaAcopioSolido.orden")}
            value={areaAcopioSolido}
            className={isInvalid ? "has-error" : ""}
            editable
            onEdit={(event) => {
              event.preventDefault();
              select(index);
              document.getElementById("areasAcopioSolidos").scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
            deletable
            onDelete={(event) => {
              event.preventDefault();
              remove(index);
            }}
            disabled={disabled}
          >
            {({ value }) => (
              <Grid>
              <Row>
                <Col>
                  <ObjectValue
                    label={t("areaAcopioSolido.solido")}
                    value={value.solido}
                  >
                    {({ value: solido }) => (
                      <Grid>
                        <Row>
                          <Col>
                            <TextValue
                              label={t("solidoAcopiado.material")}
                              value={solido.material}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <MeasureValue
                              label={t("solidoAcopiado.dimensionGrano")}
                              value={solido.dimensionGrano}
                            />
                          </Col>
                        </Row>
                      </Grid>
                    )}
                  </ObjectValue>
                </Col>
              </Row>
              <Row>
                <Col>
                  <MeasureValue
                    label={t("areaAcopioSolido.cantidad")}
                    value={value.cantidad}
                  />
                </Col>
                <Col>
                  <MeasureValue
                    label={t("areaAcopioSolido.superficie")}
                    value={value.superficie}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LabeledValue
                    label={t("areaAcopioSolido.cercoPerimetral")}
                    value={value.cercoPerimetral}
                    labelAttr="nombre"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <BooleanValue
                    label={t("areaAcopioSolido.conCerramientoSuperior")}
                    value={value.conCerramientoSuperior}
                  />
                </Col>
              </Row>
              </Grid>
            )}
          </ListGroupObjectItem>
        );
      })}
    </ListGroup>
  );
}
